export default __webpack_public_path__ + "static/media/arrow-back.72a1b752.svg";